<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

window.addEventListener("load", (event) => {
  let soldoutBtn = document.querySelector(".product-form__buttons #product-add-to-cart[disabled='true']");
  // console.log(soldoutBtn.textContent);
  if (soldoutBtn) {
    soldoutBtn.textContent = "Coming Soon";
  }
})